// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4w-1";
export var standaloneTable = "_4w-0";